import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "auth__form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Check your email", -1)
const _hoisted_3 = { class: "info size-big mb-6" }
const _hoisted_4 = { class: "info" }
const _hoisted_5 = ["onClick"]

import { useAccountStore } from '@/stores/account';
import { onMounted, ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import VInputSegmented from '../VInputSegmented.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'AuthConfirmForm',
  setup(__props) {

const accountStore = useAccountStore()
const router = useRouter()
const email = accountStore.currentUser?.email

const code = ref("")
const error = ref("")
const pending = ref(false)
const segmentInputRef = ref<{ focus(): void }>()

const requestCode = () => {
  accountStore.requestCode()
}
// onMounted(requestCode)

const activateCode = async (value: string) => {
  pending.value = true
  try {
    await accountStore.activateCode(value)
    router.push("/getting-started")
  } catch(e) {
    pending.value = false
    segmentInputRef.value?.focus()
    error.value = "Invalid code!"
  }
}

watch(code, (value) => {
  error.value = ""
  if (value.length === 4) {
    activateCode(value)
  }
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createTextVNode(" We've sent you a four-digit confirmation code to "),
      _createElementVNode("a", null, _toDisplayString(_unref(email) || "mail@mail.ru"), 1),
      _createTextVNode(". Please enter it below to confirm your email address. ")
    ]),
    _createVNode(VInputSegmented, {
      ref_key: "segmentInputRef",
      ref: segmentInputRef,
      modelValue: code.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event)),
      length: 4,
      class: "mb-2 auth__segmented-input",
      error: error.value,
      disabled: pending.value
    }, null, 8, ["modelValue", "error", "disabled"]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("a", {
        onClick: _withModifiers(requestCode, ["prevent"]),
        href: "#send-again"
      }, "Send a code again", 8, _hoisted_5)
    ])
  ]))
}
}

})